import { EventTypeInputGroupItem } from './EventTypeInputGroupItem';

export class EventTypeInputGroup {
    constructor(
        eventTypeInputGroupId: number,
        eventTypeId: number,
        heading: string,
        sectionOrder: number,
        eventTypeInputGroupItemArray: EventTypeInputGroupItem[]
    ) {
        this.eventTypeInputGroupId = eventTypeInputGroupId;
        this.eventTypeId = eventTypeId;
        this.heading = heading;
        this.sectionOrder = sectionOrder;
        this.eventTypeInputGroupItemArray = eventTypeInputGroupItemArray;
    }
    eventTypeInputGroupId: number;
    eventTypeId: number;
    heading: string;
    sectionOrder: number;
    eventTypeInputGroupItemArray: EventTypeInputGroupItem[];
}
